export default {
    init() {
        this.clientsListPaginationInput();
        this.checkAllClientsToggle();
        this.clientListActionsToggle();
    },

    clientsListPaginationInput() {
        $('.pagination-input .pages-control i').on('click', function () {
            let paginationInput = $('.pagination-input input');
            if ($(this).hasClass('up')) {
                paginationInput.val(parseInt(paginationInput.val()) + 1);
            } else {
                paginationInput.val(parseInt(paginationInput.val()) - 1);
            }

            if (paginationInput.val() < 1) {
                paginationInput.val(1);
            }
        });
    },

    checkAllClientsToggle() {
        $('.check-all').on('change', function () {
            let lotsListItem = $('.clients-list-view--body > .clients-list-view--item-row:not(:hidden)');

            if ($(this).is(':checked')) {
                lotsListItem.each(function (i, val) {
                    $(val).find('.clients-item-checkbox').first().prop('checked', true);
                });
            } else {
                lotsListItem.each(function (i, val) {
                    $(val).find('.clients-item-checkbox').first().prop('checked', false);
                });
            }
        });
    },


    clientListActionsToggle() {
        let moreActionsBtn = $('.column.actions .actions-more');

        moreActionsBtn.on('click', function (e) {
            e.preventDefault();

            let thisDrop = $(this).parent().find('.actions-drop');
            let drops = $('.actions-drop');
            drops.removeClass('current');
            thisDrop.addClass('current');

            let dropdowns = $('.actions-drop:not(.current)');
            dropdowns.removeClass('active');

            thisDrop.toggleClass('active');
        });

        let dropdowns = $('.actions-drop');

        $('body').on('click', function (e) {
            if (!moreActionsBtn.is(e.target) && moreActionsBtn.has(e.target).length === 0 && !dropdowns.is(e.target) && dropdowns.has(e.target).length === 0) {
                dropdowns.removeClass('active');
            }
        });
    }


}